// extracted by mini-css-extract-plugin
module.exports = {"headerBody":"HeaderBody_headerBody__26g2r"};